import {
  FormGroup,
  Box,
  FormLabel,
  FormControl,
  ListItemText,
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  InputLabel,
  MenuItem,
  Button,
  ButtonGroup,
  IconButton,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import PropagateLoader from 'react-spinners/PropagateLoader';
import Backdrop from '@mui/material/Backdrop';
import MUIDataTable from 'mui-datatables';
import SampleListView from '../../List/SampleListView';

import React, {
  useState,
  useRef,
  useContext,
  Redirect,
  useEffect,
} from 'react';
const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV

function CurrentOrdersTable(props) {
  const [isChecked, setIsChecked] = useState(false);
  const data = props.orders;
  const current = props.current;
  const user = props.user;

  var researchers = [];
  console.log(data)
  data.forEach((item) => {
    if (item.researcherName === undefined) {
    } else {
      if (!(researchers.includes(item.researcherName))) {
        researchers = [ ...researchers, item.researcherName ];
      }
    }
  });

  // const data = [
  //     // dummy data: [orderCode, dropLocation, status, billingStatus, billingCycle, dateDroppedOff, active]
  //     ['ABC1', 'EBB', 'Received', 'Pending', 'Summer 2022', '07/17/2022', true],
  //     ['BCD_03', 'Cherry Emerson', 'Received', 'Billed', 'Spring 2024', '04/23/2024', true],
  //     ['ABC4', 'EBB', 'Processing', 'Billed', 'Fall 2022', '10/12/2022', true],
  //     ['CCC6', 'MoSE', 'Processing', 'Billed', 'Fall 2022', '11/01/2022', true],
  //     ['CCC6', 'MoSE', 'Received', 'Billed', 'Fall 2023', '11/01/2023', true],
  //     ['CCC6', 'MoSE', 'Processing', 'Billed', 'Fall 2024', '11/01/2024', true],
  //     ['NNN7', 'IBB', 'Completed', 'Free', 'Spring 2023', '03/21/2023', true],
  //     ['NNN7', 'Cherry Emerson', 'Completed', 'Free', 'Spring 2022','03/21/2022', true],
  //     ['BCD_08', 'EBB', 'Received', 'Free', 'Fall 2023', '09/02/2023', true],
  //     ['CCC9', 'ES&T', 'Processing', 'Pending', 'Summer 2021','06/30/2021', true],
  //     ['BCD_10', 'Marcus', 'Received', 'Billed', 'Fall 2021', '11/12/2021', true],
  //     ['NNN11', 'EBB', 'Processing', 'Billed', 'Fall 2021','10/29/2021', true]
  // ]

  // dummy data but as an array of objects
  const data1 = [
    {
      orderCode: 'ABC1',
      dropLocation: 'EBB',
      status: 'Received',
      billingStatus: 'Billed',
      billingCycle: 'Summer 2022',
      dateDroppedOff: '07/17/2022',
      active: true,
    },
    {
      orderCode: 'BCD_03',
      dropLocation: 'cheRryEmersOn',
      status: 'Received',
      billingStatus: 'Pending',
      billingCycle: 'Spring 2024',
      dateDroppedOff: '04/23/2024',
      active: true,
    },
    {
      orderCode: 'ABC4',
      dropLocation: 'EBB-',
      status: 'Processing',
      billingStatus: 'Billed',
      billingCycle: 'Fall 2022',
      dateDroppedOff: '11/01/2022',
      active: true,
    },
    {
      orderCode: 'NNN7',
      dropLocation: 'mose',
      status: 'Processing',
      billingStatus: 'Free',
      billingCycle: 'Spring 2022',
      dateDroppedOff: '03/21/2022',
      active: true,
    },
    {
      orderCode: 'BCD_08',
      dropLocation: 'IBB',
      status: 'Completed',
      billingStatus: 'Free',
      billingCycle: 'Spring 2022',
      dateDroppedOff: '03/29/2022',
      active: true,
    },
  ];

  const dropOffLocations = [
    'EBB',
    'Cherryemerson',
    'MoSE',
    'IBB',
    'ES&T',
    'Marcus',
  ];
  // retrieve data for orders from the backend
  // this ensures that even if the location is entered weirdly, we can still filter it out later
  data.map((order, index) => {
    if (
      order.dropLocation
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .includes(dropOffLocations[0].toLowerCase())
    ) {
      order.dropLocation = 'EBB';
      console.log(order.dropLocation);
    } else if (
      order.dropLocation
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .includes(dropOffLocations[1].toLowerCase())
    ) {
      order.dropLocation = 'Cherry Emerson';
      console.log(order.dropLocation);
    } else if (
      order.dropLocation
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .includes(dropOffLocations[2].toLowerCase())
    ) {
      order.dropLocation = 'MoSE';
    } else if (
      order.dropLocation
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .includes(dropOffLocations[3].toLowerCase())
    ) {
      order.dropLocation = 'IBB';
    } else if (
      order.dropLocation
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .includes(dropOffLocations[4].toLowerCase())
    ) {
      order.dropLocation = 'ES&T';
    } else if (
      order.dropLocation
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '')
        .includes(dropOffLocations[5].toLowerCase())
    ) {
      order.dropLocation = 'Marcus';
    }
  });

  const columns = [
    {
      label: 'Order Number',
      name: 'orderCode',
      options: {
        filter: false,
      },
    },
    {
      label: 'Researcher',
      name: 'researcher',
      options: {
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => `Researcher: ${v.map((l) => l.toUpperCase())}`,
          update: (filterList, filterPos, index) => {
            console.log('update');
            console.log(filterList, filterPos, index);
            filterList[index].splice(filterPos, 1);
            return filterList;
          },
        },
        filterOptions: {
          logic: (researcher, filters, row) => {
            if (filters.length) return !filters.includes(researcher);
            return false;
          },
          display: (filterList, onChange, index, column) => {
            return (
              <FormControl>
                <InputLabel htmlFor="select-multiple-chip">
                  Researcher
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={(selected) => selected.join(', ')}
                  onChange={(event) => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {researchers.map((item) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color="primary"
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Drop-off Location',
      name: 'dropLocation',
      options: {
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => `Drop-off Location: ${v.map((l) => l.toUpperCase())}`,
          update: (filterList, filterPos, index) => {
            console.log('update');
            console.log(filterList, filterPos, index);
            filterList[index].splice(filterPos, 1);
            return filterList;
          },
        },
        filterOptions: {
          logic: (dropLocation, filters, row) => {
            if (filters.length) return !filters.includes(dropLocation);
            return false;
          },
          display: (filterList, onChange, index, column) => {
            const dropOffLocations = [
              'EBB',
              'Cherry Emerson',
              'MoSE',
              'IBB',
              'ES&T',
              'Marcus',
            ];
            return (
              <FormControl>
                <InputLabel htmlFor="select-multiple-chip">
                  Drop-off Location
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={(selected) => selected.join(', ')}
                  onChange={(event) => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {dropOffLocations.map((item) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color="primary"
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Status',
      name: 'status',
      options: {
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => `Status: ${v.map((l) => l.toUpperCase())}`,
          update: (filterList, filterPos, index) => {
            console.log('update');
            console.log(filterList, filterPos, index);
            filterList[index].splice(filterPos, 1);
            return filterList;
          },
        },
        filterOptions: {
          logic: (status, filters, row) => {
            if (filters.length) return !filters.includes(status);
            return false;
          },
          display: (filterList, onChange, index, column) => {
            const optionValues = ['Received', 'Processing', 'Completed'];
            return (
              <FormControl>
                <InputLabel htmlFor="select-multiple-chip">
                  Order Status
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={(selected) => selected.join(', ')}
                  onChange={(event) => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map((item) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color="primary"
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Billing Status',
      name: 'billingStatus',
      options: {
        filter: false,
        sortCompare: (order) => {
          return (obj1, obj2) => {
            console.log(order);
            let val1;
            let val2;
            if (obj1.data === 'Free') {
              val1 = 3;
            } else if (obj1.data === 'Pending') {
              val1 = 2;
            } else if (obj1.data === 'Billed') {
              val1 = 1;
            }

            if (obj2.data === 'Free') {
              val2 = 3;
            } else if (obj2.data === 'Pending') {
              val2 = 2;
            } else if (obj2.data === 'Billed') {
              val2 = 1;
            }

            //console.log("val1: "+val1)
            //console.log("val2: "+val2)
            return (val1 - val2) * (order === 'asc' ? 1 : -1);
          };
        },
        customFilterListOptions: {
          render: (v) => `Billing Status: ${v.map((l) => l.toUpperCase())}`,
          update: (filterList, filterPos, index) => {
            console.log('update');
            console.log(filterList, filterPos, index);
            filterList[index].splice(filterPos, 1);
            return filterList;
          },
        },
        filterOptions: {
          logic: (billingStatus, filters, row) => {
            if (filters.length) return !filters.includes(billingStatus);
            return false;
          },
          display: (filterList, onChange, index, column) => {
            const optionValues = ['Pending', 'Billed', 'Free'];
            return (
              <FormControl>
                <InputLabel htmlFor="select-multiple-chip">
                  Billing Status
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={(selected) => selected.join(', ')}
                  onChange={(event) => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map((item) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color="primary"
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Billing Cycle',
      name: 'billingCycle',
      options: {
        filter: true,
        display: 'true',
        filterType: 'dropdown',
        customFilterListOptions: {
          render: (v) => `Billing Cycle: ${v}`,
        },
        sortCompare: (order) => {
          return (obj1, obj2) => {
            let ayear = obj1.data.match(/\d+/g)[0];
            console.log('ayear:' + ayear);
            let byear = obj2.data.match(/\d+/g)[0];
            if (byear < ayear) {
              return -1 * (order === 'asc' ? 1 : -1);
            } else if (byear > ayear) {
              return 1 * (order === 'asc' ? 1 : -1);
            } else {
              let aterm = -1;
              if (obj1.data.toLowerCase().includes('fall')) {
                aterm = 3;
              } else if (obj1.data.toLowerCase().includes('summer')) {
                aterm = 2;
              } else if (obj1.data.toLowerCase().includes('spring')) {
                aterm = 1;
              }
              let bterm = -1;
              if (obj2.data.toLowerCase().includes('fall')) {
                bterm = 3;
              } else if (obj2.data.toLowerCase().includes('summer')) {
                bterm = 2;
              } else if (obj2.data.toLowerCase().includes('spring')) {
                bterm = 1;
              }
              if (bterm < aterm) {
                return -1 * (order === 'asc' ? 1 : -1);
              }
              if (bterm > aterm) {
                return 1 * (order === 'asc' ? 1 : -1);
              }
              return 0;
            }
          };
        },
      },
    },
    {
      label: 'Date of Submission',
      name: 'date',
      options: {
        filter: true,
        display: 'true',
        sortDirection: 'desc',
        customBodyRender: (value) => {
          return new Date(value).toLocaleDateString();
        },
        filterType: 'custom',
        customFilterListRender: (v) => {
          if (v[0] && v[1] && isChecked) {
            return [`Start Date: ${v[0]}`, `End Date: ${v[1]}`];
          } else if (v[0] && v[1] && !isChecked) {
            return `Start Date: ${v[0]}, End Date: ${v[1]}`;
          } else if (v[0]) {
            return `After this date: ${v[0]}`;
          } else if (v[1]) {
            return `Before this date: ${v[1]}`;
          }
          return false;
        },
        filterOptions: {
          names: [],
          logic(date, filters) {
            var check = new Date(date);
            var from = new Date(filters[0]);
            var to = new Date(filters[1]);
            from.setDate(from.getDate() + 1);
            to.setDate(to.getDate() + 1);
            if (filters[0] && filters[1]) {
              return check <= from || check >= to;
            } else if (filters[0]) {
              return check <= from;
            } else if (filters[1]) {
              return check >= to;
            }
            return false;
          },
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel>Date of Submission</FormLabel>
              <br></br>
              <FormGroup row>
                <TextField
                  id="startDate"
                  label="Start Date"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={filterList[index][0] || ''}
                  onChange={(event) => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: '60%', marginRight: '5%' }}
                />
                <TextField
                  id="endDate"
                  label="End Date"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={filterList[index][1] || ''}
                  onChange={(event) => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: '60%', marginRight: '5%' }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isChecked}
                      onChange={(event) => setIsChecked(event.target.checked)}
                    />
                  }
                  label="Separate Values"
                  style={{ marginLeft: '0px' }}
                />
              </FormGroup>
            </div>
          ),
        },
        print: false,
      },
    },
    {
      label: 'View Samples',
      name: 'viewSamples',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const orderCodeForRow = tableMeta.rowData[0]; // Assuming orderCode is the first column in the data.
          return <SampleListView orderCode={orderCodeForRow} buttonTitle="View Samples" />;
        },
        print: false,
      },
    },    
    {
      label: 'Active',
      name: 'active',
      options: {
        filter: false,
        display: 'excluded',
      },
    },
  ];

  const options = {
    filter: true,
    filterType: 'multiselect',
    print: false,
    viewColumns: false,
    responsive: 'standard',
    selectableRowsHideCheckboxes: true,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: 'primary',
        variant: 'outlined',
        className: 'testClass123',
      };
    },
  };

  return (
    <div>
      <Grid
        container
        direction="column"
        alignItems="center"
        spacing={0}
        margin={0}
      >
        {/* <Backdrop sx={{ color: '#fff', zIndex: 1 }} open={getLoad}>
          <PropagateLoader />
        </Backdrop> */}
      </Grid>
      <MUIDataTable
        title={'Current Orders'}
        data={data.map((item) => {
          // if (current == "onlyMy") {
          //   if (item.researcherName == user.firstName + ' ' + user.lastName) {
          //     console.log(item);
          //     return [
          //       item.orderCode,
          //       item.researcherName,
          //       item.dropLocation,
          //       item.status,
          //       item.billingStatus,
          //       item.billingCycle,
          //       item.dateDroppedOff,
          //       item.active,
          //     ];
          //   }
          // } else if (current == "onlyOther") {
          //   if (item.researcherName != user.firstName + ' ' + user.lastName) {
          //     return [
          //       item.orderCode,
          //       item.researcherName,
          //       item.dropLocation,
          //       item.status,
          //       item.billingStatus,
          //       item.billingCycle,
          //       item.dateDroppedOff,
          //       item.active,
          //     ];
          //   }
          // } else {
            return [
              item.orderCode,
              item.researcherName,
              item.dropLocation,
              item.status,
              item.billingStatus,
              item.billingCycle,
              item.dateDroppedOff,
              item.active,
            ];
          // }
        })}
        columns={columns}
        options={options}
      />
    </div>
  );
}

export default CurrentOrdersTable;
